export default function ShareController() {

}